import { Stack } from 'rsuite';
import i18n from "i18next";
import { Outlet } from 'react-router-dom';
import Balance from 'src/components/Balance';
import PayMessage from 'src/components/PayMessage';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ClientRootPage = _ref => { let {} = _ref; return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(Stack, { className: "generations", spacing: 6, direction: 'row', alignItems: 'flex-start', justifyContent: 'center', children: /*#__PURE__*/ _jsxs("span", { style: { fontWeight: 900 }, children: [i18n.t('label.generation.count'), ": ", /*#__PURE__*/ _jsx(Balance, {})] }) }), /*#__PURE__*/ _jsx(PayMessage, {}), /*#__PURE__*/ _jsx(Outlet, {})] }); };
export default ClientRootPage;
